import axios from "axios";
import { api } from "../../../../config/api";


const getOptions = () => ({
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${window.localStorage.getItem("accessToken")}`,
    },
});

const CadastroFiscalService = {
    listarPorLoja(idLoja) {
        return axios.get(
            `${api.techspdv}/api/cadastro-fiscal/loja/${idLoja}`,
            getOptions()
        );
    },

    buscarPorNcm(idLoja, ncm, page = 0, size = 10) {
        return axios.get(
            `${api.techspdv}/api/cadastro-fiscal/loja/${idLoja}/buscar`,
            {
                ...getOptions(),
                params: {
                    ncm,
                    page,
                    size,
                },
            }
        );
    },

    buscarPorId(id) {
        return axios.get(
            `${api.techspdv}/api/cadastro-fiscal/${id}`,
            getOptions()
        );
    },

    buscarPorLojaENcm(idLoja, ncm) {
        return axios.get(
            `${api.techspdv}/api/cadastro-fiscal/loja/${idLoja}/ncm/${ncm}`,
            getOptions()
        );
    },

    criar(data) {
        return axios.post(
            `${api.techspdv}/api/cadastro-fiscal`,
            data,
            getOptions()
        );
    },

    atualizar(id, data) {
        return axios.put(
            `${api.techspdv}/api/cadastro-fiscal/${id}`,
            data,
            getOptions()
        );
    },

    excluir(id) {
        return axios.delete(
            `${api.techspdv}/api/cadastro-fiscal/${id}`,
            getOptions()
        );
    },

    aplicarEmProdutos(idLoja, ncm) {
        return axios.post(
            `${api.techspdv}/api/cadastro-fiscal/aplicar-produtos`,
            {
                idLoja,
                ncm,
            },
            getOptions()
        );
    },

    sincronizarTodosProdutos(idLoja) {
        return axios.post(
            `${api.techspdv}/api/cadastro-fiscal/cadastro-fiscal/sincronizar-todos-produtos`,
            {
                idLoja,
            },
            getOptions()
        );
    },

    aplicarEmTodosProdutos(data) {
        return axios.post(
            `${api.techspdv}/api/cadastro-fiscal/cadastro-fiscal/aplicar-em-todos-produtos`,
            data,
            getOptions()
        );
    },

    importarExcel(formData) {
        return axios.post(
            `${api.techspdv}/api/cadastro-fiscal/importar-excel`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem("accessToken")}`,
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            }
        );
    },

    exportarExcel(idLoja) {
        return axios.get(
            `${api.techspdv}/api/cadastro-fiscal/loja/${idLoja}/exportar-excel`,
            {
                ...getOptions(),
                responseType: "blob",
            }
        );
    },
};

export default CadastroFiscalService;